
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account-details",
      function () {
        return require("private-next-pages/account-details/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account-details"])
      });
    }
  